import { DATABRICKS_AI_CONNECTOR_FUNCTION_NAME } from "./constants.ts";

/** A published image: its name, a tag, and the digest that tag resolves to. */
type PinnedImage = { imageName: string; tag: string; digest: string };

/**
 * The image Databricks (AI) runs, pinned to a digest: the connector's, which
 * its install Terraform reads. Move the tag and its digest together. Take the
 * digest from `docker buildx imagetools inspect <name>:<tag>`, the top-level
 * one, not a per-platform digest.
 */
export const DatabricksAiImages = {
  /**
   * The connector's Lambda image. p0-security-perimeter's docker workflow tags
   * each merge to main `sha-<7-character commit SHA>`.
   */
  connector: {
    digest:
      "sha256:cb07df600ac74e25c939a36b3b0eef57afc674e6d339cf5a216e4c411f57a09b",
    imageName: `p0security/${DATABRICKS_AI_CONNECTOR_FUNCTION_NAME}`,
    tag: "sha-551bc5e",
  },
} as const satisfies Record<string, PinnedImage>;
